import { useState } from 'react';
import { Box, Button, CodeBlock, FormattedDateTime } from '@customerio/pluma-components/react';
import { parseJSONAttribute } from '@/utils/attributes';
import { isValidTimestamp } from '@/features/people';

type ObjectAttributeValueProps = {
  value: string;
};

/** An attribute's value: JSON expands into a formatted block, a timestamp gets its calendar reading, a blank shows a dash. */
export function ObjectAttributeValue({ value }: ObjectAttributeValueProps) {
  const [isJsonExpanded, setIsJsonExpanded] = useState(false);
  const jsonValue = parseJSONAttribute(value);
  const isJson = jsonValue !== undefined;
  const isTimestamp = !isJson && isValidTimestamp(value);

  return (
    <Box pl="0">
      {isJson ? (
        <Box as="span" display="block">
          <Button variant="secondary" size="sm" mb="100" onClick={() => setIsJsonExpanded(!isJsonExpanded)}>
            {isJsonExpanded ? 'Collapse JSON' : 'Expand JSON'}
          </Button>
        </Box>
      ) : null}

      <Box as="span" display="block" overflowWrap="words" className="fs-mask" data-test-object-attribute-value>
        {jsonValue !== undefined && isJsonExpanded ? (
          <CodeBlock language="json" code={JSON.stringify(jsonValue, null, 2)} withCopyButton={false} />
        ) : value !== '' ? (
          value
        ) : (
          '–'
        )}
      </Box>

      {isTimestamp ? (
        <Box as="span" display="block">
          <FormattedDateTime date={Number(value)} format="medium_with_time" size="xxs" color="subtle" />
        </Box>
      ) : null}
    </Box>
  );
}
